import type React from "react";
import { Tabs, Tab } from "@mui/material";

interface MemorialTabsProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const MemorialTabs: React.FC<MemorialTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <Tabs
      value={activeTab}
      onChange={onTabChange}
      sx={{
        px: 2,
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 500,
          fontSize: "14px",
          color: "#757575",
          minHeight: "48px",
          "&.Mui-selected": {
            color: "#fff",
            backgroundColor: "#5d4037",
            borderRadius: "20px",
            margin: "8px 4px",
          },
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      <Tab label="Obituary" />
      <Tab label="Memories" />
      <Tab label="Donations" />
      <Tab label="Favourites" />
      <Tab label="Timeline" />
      <Tab label="Gallery" />
      <Tab label="Downloads" />
    </Tabs>
  );
};

export default MemorialTabs;
